export default "__VITE_ASSET__BBu0mgja__"